import DisplayOnBrowserMount from '@/common/components/rehydration/DisplayOnBrowserMount';
import Btn from '@/components/dataDisplay/Btn';
import { AMPLITUDE_ACTIONS } from '@/modules/core/amplitude/events';
import { LogEvent } from '@/modules/core/amplitude/types/Amplitude';
import { EducationalProgramStep } from '@/modules/core/data/types/EducationalProgramStep';
import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {
  Dispatch,
  SetStateAction,
} from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  setIsDisplayingFees: Dispatch<SetStateAction<boolean>>;
  logEvent: LogEvent;
  activeEducationalProgramStep: EducationalProgramStep;
  hasAnyTuitionFeesDescription: boolean;
}

/**
 * Button that opens the TuitionFeeContainer when clicked.
 *
 * Displayed only when there are some tuition fee description to display.
 */
const TuitionFeeButton: React.FunctionComponent<Props> = (props): JSX.Element => {
  const {
    setIsDisplayingFees,
    logEvent,
    activeEducationalProgramStep,
    hasAnyTuitionFeesDescription,
  } = props;
  const { t } = useTranslation();

  return (
    // Using "DisplayOnBrowserMount" because the CSS isn't applied correctly when the page is served through SSR, for some unknown reason - See https://app.asana.com/0/1199217463349848/1200057360187525
    <DisplayOnBrowserMount>
      <div
        css={css`
          justify-content: center;
          text-align: center;
        `}
      >
        {
          hasAnyTuitionFeesDescription && (
            <Btn
              onClick={(): void => {
                setIsDisplayingFees(true);

                logEvent('solutions-tuitionFees-displayed', {
                  selection: {
                    ref: activeEducationalProgramStep.ref,
                    isDefault: true,
                  },
                  action: AMPLITUDE_ACTIONS.CLICK,
                });
              }}
            >
              <FontAwesomeIcon icon="info-circle" />
              {t('solutionsPage.programStepFees.displayFees.button', 'Voir le prix de la scolarité')}
            </Btn>
          )
        }
      </div>
    </DisplayOnBrowserMount>
  );
};

export default TuitionFeeButton;
